
import SecuritySettingsMixin from "@/mixins/Security/SecuritySettingsMixin";
import { Mixins, Component } from "vue-property-decorator";

@Component
export default class NavigationDrawerListGroupOrders extends Mixins(
  SecuritySettingsMixin
) {}
